export enum CountryCodeType {
    Belgium = "BE",
    France = "FR",
    Germany = "DE",
    Luxembourg = "LU",
    Netherlands = "NL",
    Spain = "ES",
}
